module.exports = {
          srcSet: __webpack_public_path__ + "6400ace9423a10d8120a855cedeb6e8e-1600.png"+" 1600w",
          images:[ {path: __webpack_public_path__ + "6400ace9423a10d8120a855cedeb6e8e-1600.png",width: 1600,height: 272}],
          src: __webpack_public_path__ + "6400ace9423a10d8120a855cedeb6e8e-1600.png",
          toString:function(){return __webpack_public_path__ + "6400ace9423a10d8120a855cedeb6e8e-1600.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/AFEnev9CJGz/OB9U/zYdNf84H0L/OCdt/1Mwlv95Oqz+j029/6dmyf4AVymG/z8lbv81Ilj/NyA+/z0fOP9AI2H/TCyP/3I2qP6ZRbn/rlnF/hqjKFqJxHrgAAAAAElFTkSuQmCC",
          width: 1600,
          height: 272
        }